
export enum ReporingImageActionTypes {
    SEARCH_REPORTING_IMAGES = "SEARCH_REPORTING_IMAGES",
}

export interface IReportingImage {
    id: number,
    name: string
}

export interface ISearchReportingImages {
    count: number,
    values: Array<IReportingImage>
}


export interface ReportingImageState {
    count: number,
    reportingImages: Array<IReportingImage>,
}


export interface SearchReportingImagesAction {
    type: ReporingImageActionTypes.SEARCH_REPORTING_IMAGES,
    payload: ISearchReportingImages
}

export type ReportingImageAction = SearchReportingImagesAction;